import React, { useEffect, useState } from 'react';
import styles from './UpcomingDataCard.module.css';

const themeVars = [
  "--Primary_Color",
  "--Success_Color",
  "--Warning_Color",
  "--Error_Color",
  "--Info_Color",
];


const UpcomingDataCard = ({ index, title, value, labelType }) => {
  const [color, setColor] = useState('');

 useEffect(() => {
  const themeElement = document.querySelector('.theme');
  const randomVar = themeVars[Math.floor(Math.random() * themeVars.length)];
  const computedColor = themeElement
    ? getComputedStyle(themeElement).getPropertyValue(randomVar).trim()
    : '';
  setColor(computedColor);
}, []);


  return (
    <div
      className={styles.card}
      style={{ backgroundColor: `rgba(${hexToRgb(color)}, 0.1)` }}
    >
      <p className={styles.title} style={{ color: color }}>
        {index}. {title}
      </p>
      <p className={styles.label}>{
        labelType === 'room' ? `Room : ${value}` : `Date : ${value}`
      }</p>
    </div>
  );
};

function hexToRgb(hex) {
  hex = hex.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return `${r}, ${g}, ${b}`;
}

export default UpcomingDataCard;
